import {useEffect, useRef, useState} from 'react'
import {generatePath, useParams} from 'react-router-dom'
import {NavigateLogoIcon} from '../../assets/icons/NavigateLogoIcon'
import {Trans, useTranslation} from 'react-i18next'
import {StyledContent, StyledTextWrapper, StyledWrapper} from './style.ts'
import {formatLocaleDate} from '../../helpers/utils.js'

export const RedirectToNavigate = ({path, params}) => {
    const routeParams = useParams()
    const {t} = useTranslation()
    const timer = useRef(null)
    const [seconds, setSeconds] = useState(3)
    const [redirected, setRedirected] = useState(false)

    useEffect(() => {
        timer.current = setInterval(() => {
            setSeconds(prev => prev - 1)
        }, 1000)

        return () => {
            if (timer.current) {
                clearInterval(timer.current)
                timer.current = null
            }
        }
    }, [])

    useEffect(() => {
        if (seconds <= 0 && !redirected) {
            if (timer.current) {
                clearInterval(timer.current)
                timer.current = null
            }

            try {
                window.location.replace(
                    process.env.REACT_APP_NAVIGATE_URL +
                        (params
                            ? generatePath(path, Object.fromEntries(params.map(param => [param, routeParams[param]])))
                            : path)
                )
                setRedirected(true)
            } catch (e) {
                setRedirected(false)
            }
        }
    }, [seconds, redirected])

    return (
        <div className={'container h-100 align-items-center d-flex justify-content-center'}>
            <StyledContent>
                <NavigateLogoIcon />
                <StyledWrapper>
                    <StyledTextWrapper>
                        <h1>{t('redirect_page:title')}</h1>
                        <p>
                            <Trans
                                i18nKey="redirect_page:description"
                                components={{strong: <strong />}}
                                values={{date: formatLocaleDate('2025-08-28', 'LL')}}
                            />
                        </p>
                    </StyledTextWrapper>

                    {seconds <= 0 ? (
                        <a href={process.env.REACT_APP_NAVIGATE_URL}>{t('redirect_page:nothing_happens')}</a>
                    ) : (
                        <p>
                            <Trans
                                i18nKey="redirect_page:redirecting"
                                components={{strong: <strong />}}
                                values={{seconds}}
                            />
                        </p>
                    )}
                </StyledWrapper>
            </StyledContent>
        </div>
    )
}
